module.exports = __webpack_public_path__ + "img/cash.65b28d2f.gif";